import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
// sweet alert
import VueSweetalert2 from 'vue-sweetalert2'; 
import 'sweetalert2/dist/sweetalert2.min.css';
// cookies 
import VueCookies from 'vue-cookies'

import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

import App from './App.vue'
 
// Global registration for vue typeahead
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

// lodash
import _ from "lodash";
Vue.prototype._ = _;

// Vue Router
import router from './router'

// Vuex Store
import store from './store/index'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/styles/index.scss' // global css

import '@/icons' // icon
import '@/permission' // permission control
 
Vue.use(VueCookies);

Vue.use(VueSweetalert2);

// set ElementUI lang to EN
Vue.use(ElementUI, { locale })
// Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})